import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';
import { typeOf } from '../_functions';


function asArray(value) {
  return Array.isArray(value) ? value : [value];
}


export const validRadius = (radius) => {
  const result = asArray(radius).map(value => {
    if (typeOf(value) == 'number' && !isNaN(value)) {
      return Math.max(value, 0);
    } else {
      return value;
    }
  })

  return result;
};


export class BorderRadius extends Mixin {
  style({$}, [
    radius = $.borderRadius,
    fallbackBorderRadius = false
  ]) {
    if ($.enableRounded) {
      return css`border-radius: ${validRadius(radius)}`;
    } else if (fallbackBorderRadius !== false) {
      return css`border-radius: ${fallbackBorderRadius}`;
    }
  }
};

export class BorderTopRadius extends Mixin {
  style({$}, [radius]) {
    if ($.enableRounded) {
      const r = validRadius(radius);
      return css`
        border-top-left-radius: ${r};
        border-top-right-radius: ${r};
      `
    }
  }
}

export class BorderRightRadius extends Mixin {
  style({$}, [radius]) {
    if ($.enableRounded) {
      const r = validRadius(radius);
      return css`
        border-top-right-radius: ${r};
        border-bottom-right-radius: ${r};
      `
    }
  }
}

export class BorderBottomRadius extends Mixin {
  style({$}, [radius]) {
    if ($.enableRounded) {
      const r = validRadius(radius);
      return css`
        border-bottom-right-radius: ${r};
        border-bottom-left-radius: ${r};
      `
    }
  }
}

export class BorderLeftRadius extends Mixin {
  style({$}, [radius]) {
  if ($.enableRounded) {
      const r = validRadius(radius);
      return css`
        border-top-left-radius: ${r};
        border-bottom-left-radius: ${r};
      `
    }
  }
}

export class BorderTopLeftRadius extends Mixin {
  style({$}, [radius]) {
    if ($.enableRounded) {
      const r = validRadius(radius);
      return css`border-top-left-radius: ${r};`
    }
  }
}

export class BorderTopRightRadius extends Mixin {
  style({$}, [radius]) {
    if ($.enableRounded) {
      const r = validRadius(radius);
      return css`border-top-right-radius: ${r};`
    }
  }
}

export class BorderBottomRightRadius extends Mixin {
  style({$}, [radius]) {
    if ($.enableRounded) {
      const r = validRadius(radius);
      return css`border-bottom-right-radius: ${r};`
    }
  }
}

export class BorderBottomLeftRadius extends Mixin {
  style({$}, [radius]) {
    if ($.enableRounded) {
      const r = validRadius(radius);
      return css`border-bottom-left-radius: ${r};`
    }
  }
}
